import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Alert, Button, ListGroup, Modal } from 'react-bootstrap'
import { useNavigate } from 'react-router'
import moment from 'moment-timezone'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import { FRIENDLY_SHORT_DATE_FORMAT, FRIENDLY_SHORT_TIME_FORMAT } from '@severed-links/common.redherrings-constants'
import { getReminderLog } from '@severed-links/common.redherrings-reducers/terminatorAdmin'
import PlayerListItem from '../Player/PlayerListItem'
import SeasonSelector from '../Football/SeasonSelector'
import WeekSelector from '../Football/WeekSelector'
import ResetAllTerminatorReminders from './ResetAllTerminatorReminders'
import useTerminatorAdminSeason from './useTerminatorAdminSeason'
import terminatorErrorMessage from './terminatorErrorMessage'
import * as s from '../Main/Admin/ReminderLog.scss'

const TerminatorReminderLog = () => {
  const { dispatch, seasons, seasonId, initialPhase: phase, initialWeek: week, setPickWindow } = useTerminatorAdminSeason()
  const navigate = useNavigate()
  const season = seasons.find(item => item.seasonId === seasonId) || {}
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(true)
  const [selected, setSelected] = useState(null)
  const allRows = useSelector(state => state.terminatorAdmin.reminderLog) || []
  const rows = allRows.filter(row => String(row.seasonId) === seasonId && row.seasonMode === phase && Number(row.week) === Number(week))
  useEffect(() => {
    setSelected(null)
    if (!seasonId) { setLoading(false); return }
    let active = true
    const load = async () => {
      try {
        const action = await dispatch(getReminderLog(seasonId, phase, Number(week)))
        if (action.error || action.payload?.messageType === 'error') throw new Error(action.payload?.response?.message || action.payload?.message || 'Unable to load reminders.')
        if (active) setMessage('')
      } catch (error) { if (active) setMessage(terminatorErrorMessage(error)) }
      if (active) setLoading(false)
    }
    setLoading(true); load()
    const timer = setInterval(load, 30000)
    return () => { active = false; clearInterval(timer) }
  }, [dispatch, seasonId, phase, week])
  const sent = rows.filter(row => row.status === 'sent')
  return <div className={s.container + ' ' + s.contest}>
    <section className={s.pageHeader}>
      <button className={s.goBack} aria-label='Go back' onClick={() => navigate(-1)}><FontAwesomeIcon name='chevron-left' /></button>
      <div className={s.headerCopy}><div className={s.eyebrow}>Terminator Admin</div><h2 className={s.header}>Reminder Log</h2><div className={s.subtitle}>{season.seasonName} {phase} · Week {week}</div></div>
      <div className={s.headerActions}>
        <ResetAllTerminatorReminders key={seasonId} seasonId={seasonId} seasonName={season.seasonName} />
        <SeasonSelector seasons={seasons} season={season} />
        <WeekSelector season={season} seasons={seasons} week={`${phase === 'Postseason' ? 'PW' : 'W'}${week}`} showRegularSeasonWeeks showPlayoffWeeks onSelect={value => setPickWindow(value.startsWith('PW') ? 'Postseason' : 'Regular', value.replace(/\D/g, ''))} />
      </div>
    </section>
    {message ? <Alert variant='danger'>{message}</Alert> : null}
    <section className={s.logSummary}>{[['reminders sent', sent.length], ...['email', 'text', 'push'].map(channel => [channel, sent.filter(row => row.channel === channel).length]), ['failed', rows.filter(row => row.status === 'failed').length]].map(([label, count]) => <div className={s.summaryPill} key={label}><span>{loading ? '…' : count}</span>{label}</div>)}</section>
    <section className={s.reminderCard}><div className={s.listHeader}><div>Recipient</div><div>Delivery</div></div>
      <ListGroup className={s.reminderList}>
        {!loading && rows.map(row => <PlayerListItem key={row._id} className={s.reminderRow} player={row.playerId || { firstName: 'Deleted player' }} rightDetail={<div className={s.rightDetail}>
          <span className={s.channelChip}><FontAwesomeIcon name={{ email: 'envelope', text: 'sms', push: 'mobile' }[row.channel]} /> {row.channel} · {row.status}</span>
          <div className={s.dateSent}>{moment(row.updatedAt).format(FRIENDLY_SHORT_DATE_FORMAT)}<br />{moment(row.updatedAt).format(FRIENDLY_SHORT_TIME_FORMAT)}</div>
          <Button size='sm' variant='light' onClick={() => setSelected(row)}>Details</Button>
        </div>} />)}
        {loading || !rows.length ? <ListGroup.Item className={s.emptyState}>{loading ? 'Loading…' : 'No reminders located.'}</ListGroup.Item> : null}
      </ListGroup>
    </section>
    <Modal show={!!selected} onHide={() => setSelected(null)} centered><Modal.Header closeButton><Modal.Title>Reminder details</Modal.Title></Modal.Header><Modal.Body>{selected ? <><p>{selected.playerId?.firstName} {selected.playerId?.lastName} · {selected.channel} · {selected.status}</p><p style={{ whiteSpace: 'pre-wrap' }}>{selected.message}</p></> : null}</Modal.Body></Modal>
  </div>
}
export default TerminatorReminderLog
